export enum FieldDataTableColumnType {
  DATE,
  CURRENCY,
  ID,
  ARRAY,
  LABEL
}
